module.exports = __webpack_public_path__ + "img/stock7.2b06aaf9.png";